import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=31345b4a&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=31345b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31345b4a",
  null
  
)

export default component.exports